module.exports = __webpack_public_path__ + "img/fog.ad9f4f8b.svg";